export class Simuladores {
    Fecha : Date = new Date() ;
    Tipo_Comprobante :string ="" ;
    Fecha_Desembolso :Date = new Date() ;
    Moneda :number ;
    Moneda_Dsc :string ;
    TEM :number ;
    Adelanto_Porcentaje :number ;
    Adelanto_Importe :number ;
    Interes_Importe :number ;
    Comision_Importe :number ;
    IGV_Importe :number ;
    Desembolso_Importe :number ;
    Remanente_Importe :number ;
    VNPP : number = 0;
    Num_Doc_IdentificacionP:string = '' ;
    Num_Doc_IdentificacionA:string = '' ;
    NombreAdquirente: string = '' ;
NombreProveedor:string = '' ;
Scoring_Adquirente:  number = 0;
Scoring_Proveedor: number = 0;
Url_Proforma: string = '';
UrlResumen_Proforma: string = '';
  }
  